import { useRef } from "react";
import ReactQuill from "react-quill";
import { Controller } from "react-hook-form";
import { Box } from "@chakra-ui/react";

interface Props {
  name: string;
  control: any;
  defaultValue: string | null;
  setValue: any;
}

function TextEditor({ name, control, defaultValue = "", setValue }: Props) {
  const editorRef = useRef(null);

  // Adjusted to directly use the provided newValue
  const onEditorInputChange = (newValue: string) => {
    setValue(name, newValue); // Use the 'name' prop to dynamically set the value
    localStorage.setItem(name, newValue); // Use the 'name' prop for local storage key as well
  };

  const options = {
    modules: {
      toolbar: [
        ["bold", "italic", "underline", "strike"], // toggled buttons
        ["blockquote", "code-block"],

        [{ header: 1 }, { header: 2 }], // custom button values
        [{ list: "ordered" }, { list: "bullet" }],
        [{ script: "sub" }, { script: "super" }], // superscript/subscript
        [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
        [{ direction: "rtl" }], // text direction

        [{ size: ["small", false, "large", "huge"] }], // custom dropdown
        [{ header: [1, 2, 3, 4, 5, 6, false] }],

        [{ color: [] }, { background: [] }], // dropdown with defaults
        [{ font: [] }],
        [{ align: [] }],

        ["clean"], // remove formatting button

        ["link", "image", "video"], // link and image, video
      ],
    },
    placeholder: "Compose an epic...",
    theme: "snow", // or 'bubble'
  };

  return (
    <Box height={{ base: "460px", md: "550px" }}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <ReactQuill
            style={{ height: "500px" }}
            {...field}
            onChange={(content) => onEditorInputChange(content)}
            ref={editorRef}
            theme="snow"
            modules={options.modules}
          />
        )}
      />
    </Box>
  );
}

export default TextEditor;
